(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["youtube-video-button"] && !Shopify.designMode) return;
  try {
    (function () {
  function initYvb () {
    document.querySelectorAll('.yvb-wrap[data-block-id]').forEach(function (wrap) {
      if (wrap.dataset.yvbInit) return;
      wrap.dataset.yvbInit = '1';

      var blockId  = wrap.dataset.blockId;
      var lightbox = document.getElementById('yvb-lightbox-' + blockId);
      if (!lightbox) return;

      var btn      = wrap.querySelector('.yvb-btn');
      var iframe   = lightbox.querySelector('.yvb-lightbox__iframe');
      var backdrop = lightbox.querySelector('.yvb-lightbox__backdrop');
      var closeBtn = lightbox.querySelector('.yvb-lightbox__close');

      // Move lightbox to <body> to escape all stacking contexts
      document.body.appendChild(lightbox);

      function openLightbox() {
        var videoId = wrap.dataset.videoId;
        if (!videoId) return;
        iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
        lightbox.hidden = false;
        lightbox.classList.remove('is-closing');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      }

      function closeLightbox() {
        lightbox.classList.add('is-closing');
        setTimeout(function () {
          lightbox.hidden = true;
          lightbox.classList.remove('is-closing');
          iframe.src = '';
          document.body.style.overflow = '';
          btn.focus();
        }, 180);
      }

      btn.addEventListener('click', openLightbox);
      closeBtn.addEventListener('click', closeLightbox);
      backdrop.addEventListener('click', closeLightbox);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initYvb);
  } else {
    initYvb();
  }

  // Re-init when Shopify theme editor reloads sections
  document.addEventListener('shopify:section:load', initYvb);
  document.addEventListener('shopify:block:select', initYvb);
})();
  } catch(e) { console.error(e); }
})();

})();
